export const contentIds = {
  // Guarantee header
  guaranteeTitle: "cid$#4295579#", // "{0} Guarantee"
  guaranteeDesc: "cid$#4295558#", // "Your order is 100% guaranteed"

  // Chip labels
  chipCardOnTime: "cid$#4295559#", // "On time"
  chipCardValid: "cid$#4295560#", // "Valid"
  chipProtected: "cid$#4295561#", // "Protected"

  // Benefit titles + descriptions
  benefitOnTimeTitle: "cid$#4295562#", // "Tickets in time"
  benefitOnTimeDesc: "cid$#4295563#", // "Your tickets will be ready in time for the event."
  benefitValidTitle: "cid$#4295564#", // "Tickets are valid"
  benefitValidDesc: "cid$#4295565#", // "Tickets will scan at the venue and match your order."
  benefitEventProtectionTitle: "cid$#4295566#", // "Event protection"
  benefitEventProtectionDesc: "cid$#4295568#", // "Cancelled event? Get a refund or 120% credit for future use."
  benefitSupportTitle: "cid$#4295569#", // "24/7 support"
  benefitSupportDesc: "cid$#4295570#", // "If something goes wrong, our specialists work to make it right."

  // Details link
  seeDetailsLink: "cid$#4297929#", // "See Details"
} as const;
